export default __webpack_public_path__ + "static/media/hotbit.27a00e5a.png";